import styles from './customer-product-list-grid.module.scss';
import { CreateHeaders, dateHeader, HeaderSizeEnum, textHeader, booleanHeader } from '@frontend-workspace/react-shared-lib';
import CustomerProductListGridRenderer from '../customer-product-list-grid-renderer/customer-product-list-grid-renderer';
import { ICustomerProducts } from '../../_models/customer-products';
import WebkuaTable from '../../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CustomerProductListGridProps {
  customerProducts: ICustomerProducts[],
  onIsGroupChange: (checked: boolean) => void,
  isGroup: boolean
}

export function CustomerProductListGrid(props: CustomerProductListGridProps) {
  const { t } = useTranslation();

  const headers = CreateHeaders([
    textHeader("licenseNumber", t('standard.licenseNumber'), HeaderSizeEnum.MEDIUM, {
      renderer: 'agGroupCellRenderer',
      cellStyle: { fontSize: '0.875rem', fontWeight: '600' }
    }),
    textHeader("productName", t('standard.productName'), HeaderSizeEnum.LARGE),
    textHeader("type", t('standard.type'), HeaderSizeEnum.MEDIUM),
    textHeader("variant", t('standard.variant'), HeaderSizeEnum.MEDIUM),
    textHeader("version", t('standard.version'), HeaderSizeEnum.SMALL),
    textHeader("numberOfSeats", t('standard.numberOfSeats'), HeaderSizeEnum.MEDIUM),
    dateHeader("terminationDate", t('standard.terminationDate')),
    textHeader("contractNumber", t('standard.contractNo'), HeaderSizeEnum.MEDIUM),
    booleanHeader("isHistoric", t('standard.expired'))
  ]);

  return (
    <WebkuaTable
      data={props.customerProducts}
      headers={headers}
      expandComponent={CustomerProductListGridRenderer}
      tableFilters={[{
        label: t('standard.showForGroup'),
        checked: props.isGroup,
        onChange: props.onIsGroupChange
      }]}
    />
  );
}

export default CustomerProductListGrid;